import React from 'react';
import './Chapters.scss';

function Chapter2() {
  return (
    <>
      <section className="chapter" style={{ marginBottom: '-1.5rem' }}>
        <p className="chapter__paragraph">
          Scenarios similar to this fictional example are already beginning to play out at retail
          stores and transportation hubs around the world, thanks to a unique partnership between{' '}
          <a
            href="https://www.lenovo.com/us/en/servers-storage/alliance/ai-innovators/"
            target="_blank"
            rel="sponsored"
            style={{ color: '#7A126B', textDecoration: 'none', fontWeight: 500 }}
          >
            Lenovo
          </a>{' '}
          and innovative software startups like{' '}
          <a
            href="https://sunlight.io/"
            target="_blank"
            rel="sponsored"
            style={{ color: '#7A126B', textDecoration: 'none', fontWeight: 500 }}
          >
            Sunlight.io
          </a>{' '}
          and{' '}
          <a
            href="https://pathr.ai/"
            target="_blank"
            rel="sponsored"
            style={{ color: '#7A126B', textDecoration: 'none', fontWeight: 500 }}
          >
            Pathr.ai
          </a>
          .
        </p>
        <p className="chapter__paragraph">
          Pathr.ai provides spatial intelligence software that gathers anonymous data from security
          cameras to give businesses insights into how people behave in physical spaces. “The
          feedback we’re getting is that operations are running more smoothly,” Pathr.ai CEO and
          founder George Shaw says of the company’s traffic analysis work with retailers. For one
          thing, Shaw adds, “The staff is much happier because they’re not getting whiplash being
          pulled in ten different directions.” That’s because AI tells them where to be at the right
          time to help customers—for example, at locked cases.
        </p>
        <p className="chapter__paragraph">
          This revolutionary technology isn’t limited to retail. Sunlight.io’s computing platform
          running on Lenovo edge hardware powers software from their partner, WaitTime, to help
          planners at a regional airport in the UK. Planners using the system can see how travelers
          traverse the airport, where they get stuck, how they flow through security checkpoints,
          what check-in desks they prefer, and more. Armed with that data, “They’re optimizing the
          experience of getting through security, getting checked in, and getting to the gate,” says
          Julian Chesterfield, Sunlight.io's co-founder and CEO.
        </p>
      </section>
    </>
  );
}

export default Chapter2;
